import { ROUTES } from "api/youdj/auth";
import { User } from "firebase/auth";
import { apiClient } from "lib/client";

export const ensureRegistered = (user: User) => {
    const client = apiClient(ROUTES.ensureRegistered, user);
    return client.request({});
}